export default __webpack_public_path__ + "static/about-11c1653107c2ef5d130242dcd0c45e75.svg";